<template>
  <div>
    <div class="logo-band">
      <div class="gemnote-logo">
        <img :src="data.logo || defaultLogo" alt="logo" />
      </div>
    </div>

    <div class="campaign-container">
      <div class="campaign-card">
        <div class="flex justify-center">
          <img src="../assets/Paige_EmailVerification.gif" />
        </div>

        <h4 class="campaign-title editorial">Your email has been verified.</h4>

        <p class="campaign-subtitle">
          You will be redirected to {{ data.name }} shortly.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { layouts } from '@/helpers'
import router from '@/router'

export default {
  name: 'EmailVerificationSuccess',

  data: () => ({
    defaultLogo: require('../assets/gemnote_logo_pebble.png'),
    data: {}
  }),

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  },

  mounted() {
    this.handleRedirect()
  },

  methods: {
    handleRedirect() {
      this.data = this.$route.params

      const projectInfo = this.$store.state.project.projectInfo

      console.log('rwssss', this.$store.state.project.projectInfo)

      setTimeout(() => {
        if (this.data.redirect === 'ProjectItemsSelection') {
          if (!projectInfo.products.length) {
            return router.push(
              `/admin-order-recipients/${this.data.uuid}/recipient`
            )
          } else {
            return router.push(
              `/admin-order-recipients/${this.data.uuid}/items-selection`
            )
          }
        } else {
          this.$router.push({
            name: this.data.redirect,
            params: {
              uuid: this.data.uuid
            }
          })
        }
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.campaign-container {
  height: auto;
  margin: 0 auto;
  padding-top: 6rem;
}

.campaign-card {
  padding-top: 1rem;
  margin: 0 auto;

  img {
    height: 18rem;
  }
}

.campaign-title {
  font-size: 2rem;
  padding-top: 3.5rem;
  text-transform: uppercase;
  font-weight: 400;
}

.campaign-subtitle {
  color: $main-6;
  font-size: 0.875rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

@media screen and (max-width: 1100px) and (min-width: 900px) {
  .campaign-card {
    width: 60%;
  }
}

@media screen and (max-width: 899px) and (min-width: 700px) {
  .campaign-card {
    width: 70%;
  }
}

@media screen and (max-width: 699px) and (min-width: 500px) {
  .campaign-card {
    width: 85%;
  }
}

@media screen and (max-width: 499px) and (min-width: 320px) {
  .campaign-card {
    width: 90%;
    padding: 3rem 0;
  }

  .campaign-title {
    font-size: 1rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }

  .campaign-subtitle {
    padding: 0 1rem;
    font-size: 12px;
    margin-bottom: 3rem;
  }
}
</style>
